import { createSlice } from '@reduxjs/toolkit';
import {
  GET_SEARCH_RESULTS,
  UPDATE_TOPIC,
  DELETE_TOPIC,
  UPDATE_CHECKLIST,
  DELETE_CHECKLIST,
  UPDATE_PART,
  DELETE_PART,
  UPDATE_CHAPTER,
  DELETE_CHAPTER
} from '../constants/constants';

const initialState = {
  data: [],
  total_count: 0,
  total_pages: 0,
  total_showing: 0
};

const UPDATE_ACTIONS = [UPDATE_PART, UPDATE_CHAPTER, UPDATE_TOPIC, UPDATE_CHECKLIST];
const DELETE_ACTIONS = [DELETE_PART, DELETE_CHAPTER, DELETE_TOPIC, DELETE_CHECKLIST];

const searchesSlice = createSlice({
  name: 'searches',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(GET_SEARCH_RESULTS, (state, action) => ({ ...state, ...action.data }))
      .addMatcher(
        action => UPDATE_ACTIONS.includes(action.type),
        (state, action) => {
          state.data.forEach(search => {
            if(search.item._id.$oid === action.data._id.$oid) {
              search.item.title = action.data.title;
            }
          });
        }
      )
      .addMatcher(
        action => DELETE_ACTIONS.includes(action.type),
        (state, action) => {
          state.data = state.data.filter(search => search.item._id.$oid !== action.data._id.$oid);
        }
      );
  }
});

export default searchesSlice.reducer;
